// extracted by mini-css-extract-plugin
export default {"container":"sLAfEGfLJ1RMEvIz4VJR"};